import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import {
  TextInput,
  FloatInput,
} from "components/Input/Index.js";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { memberclaim } from "variables/markets";
import { putMarketMembershipClaim, getMarketMemberships, getFiles } from "services/ConfigServices";
import { MarketsContext } from "context/MarketsContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Chip from "@mui/material/Chip";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "97%",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "97%",
  },
}));


const Subsectiontitle = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
margin-top: 15px;
`;

function EditClaimDialog(props) {
  const { closeModal, refetch, claim } = props;
  const appContext = useContext(MarketsContext);
  const { market } = appContext;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [marketmembershipname, setMarketmembershipname] = useState(claim.parameters?.marketmembershipname);
  const [marketmembershipnumber, setMarketmembershipnumber] = useState(claim.parameters?.marketmembershipnumber);
  const [membershipGroup, setMembershipGroup] = useState(claim.parameters?.membershipGroup);;

  const [purpose, setPurpose] = useState(claim.parameters?.purpose);
  const [detail, setDetail] = useState(claim.parameters?.detail);
  const [amountasked, setAmountasked] = useState(claim.parameters?.amountasked);
  const [associatedfiles, setAssociatedfiles] = useState(claim.parameters?.associatedfiles || []);

  const [groups, setGroups] = useState("");
  const [groupsParent, setGroupsParent] = useState(
    market?.parameters?.general?.groups?.[0]
  );

  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleSubmit = async (event) => {
    updateClaim(event);
  };

  const handlePurposeChange = (event) => { setPurpose(event.target.value); };
  const handleDetailChange = (event) => { setDetail(event.target.value); };
  const handleAmountaskedChange = (event) => { setAmountasked(event.target.value); };

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  useEffect(() => {
    if (membershipGroup) {
      axios
        .get(getFiles(membershipGroup), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setGedList(res.data.collection || []);
        });
    }
  }, [membershipGroup]);

  const selectedDocuments = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };
  const handleAssociatedfilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociatedfiles(newArray);
  };

  const updateClaim = async (event) => {
    await axios
      .put(
        putMarketMembershipClaim(claim.id),
        {
          ...claim.parameters,
          purpose,
          detail,
          amountasked,
          associatedfiles,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Réclamation mise à jour");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                isRequired
                inputTitle={memberclaim.marketmembershipname}
                textInput={marketmembershipname}
                disabled
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={memberclaim.marketmembershipnumber}
                textInput={marketmembershipnumber}
                disabled
              />
            </div>

            <Subsectiontitle>Réclamation</Subsectiontitle>
            <div>
              <TextInput
                isRequired
                inputTitle={memberclaim.purpose}
                textInput={purpose}
                handleTextInputChange={handlePurposeChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={memberclaim.detail}
                textInput={detail}
                handleTextInputChange={handleDetailChange}
                multiline={true}
                rows={5}
              />
            </div>
            <div>
              <FloatInput
                isRequired
                inputTitle={memberclaim.amountasked}
                floatInput={amountasked}
                handleFloatInputChange={handleAmountaskedChange}
              />
            </div>
            <div>
              <AutocompleteInput
                isMultiple={true}
                specialWidth={"97%"}
                inputTitle={memberclaim.associatedfiles}
                selected={selectedDocuments()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((option, index) => (
                    <Chip label={option.title} {...getTagProps({ index })} />
                  ))
                }
              />
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Modifier
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}
export default EditClaimDialog;
